<section class="app__discovery_section--content">
  @if(!isFromNetworkSetup || isFromNetworkSetup && mySuggestions.length > 0){
  <ng-container>
    <div
      class="w-full relative mx-auto bg-[#FAFAFA]"
      [ngClass]="{
        'px-0 py-0 pr-0 pl-0 pt-0': isFromNetworkSetup,
        'px-6 pt-8 overflow-y-auto': !isFromNetworkSetup,
        'h-[calc(100vh-135px)]': switchFromUser,
      }"
    >
      <section class="w-full mx-auto relative">
        <!-- Description Text -->
        <div class="mb-4" *ngIf="!isFromNetworkSetup">
          <p class="text-[14px] text-[#6B7280] font-normal m-0">Description</p>
        </div>

        <!-- Search Bar -->
        <div class="app__discovery--header--search--field mt-[15px] mb-[20px] bg-[#FFFFFF] rounded-lg">
          <div class="app__centered-item w-full h-full px-5">
            <span> <img src="../../../../../../assets/images/blue-search-icon.svg" /> </span>
            <input
              class="h-full w-full ml-2 border-none outline-none"
              [(ngModel)]="searchtext"
              type="text"
              placeholder="Search Suggestions"
              autocomplete="off"
              #searchTemplatesInput
            />
            @if (searchtext) {
            <span (click)="clearSearchAction()" class="material-icons relative bg-white text-[#898F9E] text-2xl hover:cursor-pointer">clear</span>
            }
          </div>
        </div>

        <!-- Suggestions Header -->
        <div class="flex justify-between items-baseline w-full mb-4">
          <h2 class="text-[14px] font-open-sans not-italic font-bold leading-[30px] text-[#010B18] m-0">
            Suggestions
            <span class="font-bold text-[#25508e]"> ({{ getFilteredSuggestionsCount() }}) </span>
          </h2>
        </div>

        <!-- Table Header -->
        <div class="mb-2 bg-transparent">
          <div class="flex items-center px-3 py-3">
            <div class="flex items-center w-8">
              <mat-checkbox
                type="checkbox"
                class="checkbox-input custom-individual-checkBox"
                [checked]="selectAll"
                [(ngModel)]="selectAll"
                (change)="onSelectAllChange($event)"
              >
              </mat-checkbox>
            </div>
            <div class="flex items-center w-8"></div>
            <div class="flex items-center flex-1 cursor-pointer">
              <span class="text-[14px] font-[400] text-[#707070] mr-2" (click)="toggleSort()">Name</span>
              <span class="material-icons text-sm text-[#6B7280]" (click)="toggleSort()">
                {{ sortDirection === 'asc' ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
              </span>
            </div>
            <div class="flex items-center w-48">
              <span class="text-[14px] font-[400] text-[#707070]"></span>
            </div>
            <div class="flex items-center w-20">
              <!-- Actions column header -->
            </div>
          </div>
        </div>

        @if (getFilteredSuggestions().length > 0) {
        <div class="w-full">
          @for (suggestion of getFilteredSuggestions(); track suggestion; let i = $index) {
          <div class="action__item__suggestion-container bg-white h-[69px] px-3 py-3 my-2 rounded-lg border border-gray-200">
            <div class="flex items-center w-full">
              <!-- Checkbox Column -->
              <div class="flex items-center w-8 mr-2">
                <mat-checkbox
                  type="checkbox"
                  class="checkbox-input custom-individual-checkBox"
                  [checked]="suggestion.selected"
                  [(ngModel)]="suggestion.selected"
                  (change)="onSuggestionSelectChange(suggestion, $event)"
                >
                </mat-checkbox>
              </div>

              <!-- Avatar Column -->
              <div class="flex items-center w-10">
                <ngx-avatars
                  size="36"
                  src="{{ suggestion.profile_image_url }}"
                  name="{{ suggestion.name | titlecase }}"
                  [round]="true"
                  initialsSize="2"
                ></ngx-avatars>
              </div>

              <!-- Name Column -->
              <div
                class="flex items-center ml-2"
                [ngClass]="{
        'w-[50%]': isFromNetworkSetup,
        'w-[59%]': !isFromNetworkSetup,
              }"
              >
                <h3 class="action__item__suggestion--info--name m-0 text-[14px] font-semibold text-gray-900">
                  {{ suggestion.name | truncateStrPipe : 23 }}
                </h3>
              </div>

              <div class="flex justify-between items-center w-[50%]">
                <!-- Mutual Connections Column -->
                <div
                  class="flex items-center"
                  [ngClass]="{
                  'w-48': !isFromNetworkSetup,
                  'w-fit': isFromNetworkSetup,
                }"
                >
                  <span class="mutual-connections-count text-[14px] text-[#898F9E] cursor-pointer underline" (click)="mutualConnection(suggestion)">
                    {{ getMutualConnectionsCount(suggestion) }} Mutual {{ getMutualConnectionsCount(suggestion) > 1 ? 'Connections' : 'Connection' }}
                  </span>
                </div>

                <!-- Actions Column -->
                <button
                  class="w-20"
                  [id]="'add_' + suggestion.name"
                  (click)="acceptRequest(suggestion)"
                  [ngClass]="{
                    'app__btn--primary--small m-0 px-[25px] py-[6px] sm:text-sm text-xxs bg-[#25508E] text-white rounded-md hover:bg-[#123260] transition-colors': !isFromNetworkSetup,
                    'app__small__primary__button': isFromNetworkSetup,
                  }"
                >
                  Add
                </button>
                <button
                  mat-icon-button
                  [matMenuTriggerFor]="suggestionMenu"
                  class=""
                  [ngClass]="{
                      'app__menu__button': isFromNetworkSetup,
                      'suggestion-menu-btn hover:bg-[#EBEBEB] p-0 rounded-[4px] h-[32px] w-[35px]': !isFromNetworkSetup,
                            }"
                  [disableRipple]="true"
                >
                  <span class="material-icons text-[#25508E]">more_vert</span>
                </button>
                <mat-menu #suggestionMenu="matMenu" yPosition="below" xPosition="before">
                  <button mat-menu-item (click)="removeSuggestions(suggestion)" class="remove-suggestion-item p-2">
                    <div class="flex items-center">
                      <span class="material-icons remove-icon mr-2">remove_circle_outline</span>
                      <span>Remove Suggestion</span>
                    </div>
                  </button>
                </mat-menu>
              </div>
            </div>
          </div>
          }
        </div>
        } @else { @if (searchtext) {
        <!-- Search zero state -->
        <div class="flex gap-4 py-5 h-fit fl-al-center flex-col items-center justify-center">
          <div class="flex" style="height: 84px; width: 84px">
            <img src="assets/images/no-matchin-result.svg" />
          </div>
          <div style="color: #18191c">
            <div class="font-semibold" style="font-size: 22px; margin-bottom: 8px; line-height: 24px">No matching results to show</div>
            <div class="text-sm font-normal text-center">Try different search terms</div>
          </div>
        </div>
        } @else {
        <!-- Default zero state -->
        <div class="flex justify-center items-center flex-wrap gap-5 mx-auto w-full mt-8">
          <p class="text-lg text-center text-gray-500">No <span class="font-bold text-[#25508E]">suggestions</span> to show</p>
        </div>
        } }
      </section>
    </div> </ng-container
  >} @if(isFromNetworkSetup && mySuggestions.length === 0){
  <div class="flex flex-col zero-state justify-center items-center gap-4 mx-auto w-full mt-[42px] rounded-lg border border-[#53565b26] py-8 h-fit">
    <img src="assets/images/group-network-zero-state.svg" alt="no-suggestions" class="w-[62px] h-[62px] p-3" />
    <p class="text-base font-medium text-[#18191C] font-open-sans m-0 text-sm">
      No <span class="font-bold text-[#25508E]">suggestions</span> to show
    </p>
    <button
      class="app__small__primary__button--icon m-0 mt-0"
      (click)="moveToNextStepEmitter.emit()"
      style="margin: 0 !important; margin-top: 0 !important"
    >
      Move to Next Step
    </button>
  </div>
  }
</section>
@if (selectedSuggestions?.length > 0) {
<network-float-action
  class="absolute left-[50%] translate-x-[-50%] w-fit z-[20000]"
  [ngClass]="{ 'bottom-[40px]': switchFromUser, 'bottom-[24px]': !switchFromUser }"
  [isFromNetworkSetup]="isFromNetworkSetup"
  [selectedItems]="selectedSuggestions"
  [componentType]="'suggestions'"
  (actionClick)="onFloaterAction($event)"
></network-float-action>
}
